<template>
  <div :class="distinguish == 2 ? 'cola-list1' : 'cola-list'">
    <!-- 1 -->
    <div :class="distinguish == 2 ? 'disaster-now' : 'disaster-nowr'">
      <div class="disaster-top">
        <img
          :src="disasterber == 0 ? list[0] : list1[0]"
          @click="disaster(0)"
          @mouseover="touch(0)"
          @mouseleave="touch1()"
          alt
        />
      </div>
      <span
        :class="setat == 0 ? 'name1' : 'name'"
        :style="{
          backgroundImage: disasterber == 0 ? `url(${imga})` : `url(${imga1})`,
        }"
      >瓦斯</span>
    </div>
    <!-- 2 -->
    <div :class="distinguish == 2 ? 'disaster-now2' : 'disaster-nowr2'">
      <div class="disaster-top">
        <img
          :src="disasterber == 1 ? list[1] : list1[1]"
          :class="disasterber == 1 ? 'a' : ''"
          @mouseover="touch(1)"
          @mouseleave="touch1()"
          @click="disaster(1)"
          alt
        />
      </div>
      <span
        :class="setat == 1 ? 'name1' : 'name'"
        :style="{
          backgroundImage: disasterber == 1 ? `url(${imga})` : `url(${imga1})`,
        }"
      >粉尘</span>
    </div>
    <!-- 3 -->
    <div :class="distinguish == 2 ? 'disaster-now3' : 'disaster-nowr3'">
      <div class="disaster-top">
        <img
          :src="disasterber == 2 ? list[2] : list1[2]"
          :class="disasterber == 2 ? 'a' : ''"
          @mouseover="touch(2)"
          @mouseleave="touch1()"
          @click="disaster(2)"
          alt
        />
      </div>
      <span
        :class="setat == 2 ? 'name1' : 'name'"
        :style="{
          backgroundImage: disasterber == 2 ? `url(${imga})` : `url(${imga1})`,
        }"
      >水灾</span>
    </div>
    <!-- 4 -->
    <div :class="distinguish == 2 ? 'disaster-now4' : 'disaster-nowr4'">
      <div class="disaster-top">
        <img
          :src="disasterber == 3 ? list[3] : list1[3]"
          :class="disasterber == 3 ? 'a' : ''"
          @mouseover="touch(3)"
          @mouseleave="touch1()"
          @click="disaster(3)"
          alt
        />
      </div>
      <span
        :class="setat == 3 ? 'name1' : 'name'"
        :style="{
          backgroundImage: disasterber == 3 ? `url(${imga})` : `url(${imga1})`,
        }"
      >火灾</span>
    </div>
    <!-- 5 -->
    <div :class="distinguish == 2 ? 'disaster-now5' : 'disaster-nowr5'">
      <div class="disaster-top">
        <img
          :src="disasterber == 4 ? list[4] : list1[4]"
          alt
          @mouseover="touch(4)"
          @mouseleave="touch1()"
          @click="disaster(4)"
        />
      </div>
      <span
        :class="setat == 4 ? 'name1' : 'name'"
        :style="{
          backgroundImage: disasterber == 4 ? `url(${imga})` : `url(${imga1})`,
        }"
      >避灾路线</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CoalMineColaright",

  data() {
    return {
      setat: null,
      distinguish: null,
      disasterber: -1,
      list: [
        require("../../../assets/zh/ws0.png"),
        require("../../../assets/zh/fc1.png"),
        require("../../../assets/zh/sz2.png"),
        require("../../../assets/zh/hz3.png"),
        require("../../../assets/zh/bzlx4.png"),
      ],
      list1: [
        require("../../../assets/zh/ws.png"),
        require("../../../assets/zh/fc.png"),
        require("../../../assets/zh/sz.png"),
        require("../../../assets/zh/hz.png"),
        require("../../../assets/zh/bzlx.png"),
      ],
      imga: require("../../../assets/sb/back.png"),
      imga1: require("../../../assets/sb/back1.png"),
    };
  },

  mounted() {
    // 接收 zdy传入
    this.emit.$on("distinguish", (e) => {
      this.distinguish = e;
    });
  },

  methods: {
    disaster(i) {
      if (this.disasterber == i) {
        this.disasterber = 100;
        return;
      }
      this.disasterber = i;
    },
    touch(i) {
      this.setat = i;
    },
    touch1() {
      this.setat = 100;
    },
  },
};
</script>

<style lang="less" scoped>
.cola-list1 {
  width: 100%;
  height: 100%;
  transition: all 1s;
  position: absolute;
  background-image: url("../../../assets/arc.png");
  background-size: 40% auto;
  background-repeat: no-repeat;
  background-position-x: 1.5vw;
  transform: translateX(5%);
}
.cola-list {
  width: 100%;
  height: 100%;
  transition: all 1s;
  position: absolute;
  transform: translateX(-115%);
  background-image: url("../../../assets/arc.png");
  background-repeat: no-repeat;
  background-position-x: 1.5vw;
  background-size: 40% auto;
}
.disaster-now {
  width: 12vw;
  padding: 0.2vh 0.5vw;
  display: flex;
  align-items: center;
  margin-top: 10vh;
  margin-left: 0.5vw;
  .keyframesA();
}
.disaster-nowr {
  padding: 0.2vh 0.5vw;
  display: flex;
  align-items: center;
  margin-top: 10vh;
  margin-left: 0.5vw;
}

.disaster-now2 {
  padding: 0.2vh 0.5vw;
  display: flex;
  align-items: center;
  margin-top: 2vh;
  margin-left: -0.3vw;
  .keyframesA(@delay:0.8s);
}
.disaster-nowr2 {
  padding: 0.2vh 0.5vw;
  display: flex;
  align-items: center;
  margin-top: 2vh;
  margin-left: -0.3vw;
}

.disaster-now3 {
  padding: 0.2vh 0.5vw;
  display: flex;
  align-items: center;
  margin-top: 3vh;
  margin-left: -0.5vw;
  .keyframesA(@delay:1s);
}
.disaster-nowr3 {
  padding: 0.2vh 0.5vw;
  display: flex;
  align-items: center;
  margin-top: 3vh;
  margin-left: -0.5vw;
}

.disaster-now4 {
  padding: 0.2vh 0.5vw;
  display: flex;
  align-items: center;
  margin-top: 2vh;
  margin-left: 0.3vw;
  .keyframesA(@delay:1.2s);
}
.disaster-nowr4 {
  padding: 0.2vh 0.5vw;
  display: flex;
  align-items: center;
  margin-top: 2vh;
  margin-left: 0.3vw;
}

.disaster-now5 {
  padding: 0.2vh 0.5vw;
  display: flex;
  align-items: center;
  margin-top: 2vh;
  margin-left: 1.5vw;
  .keyframesA(@delay:1.4s);
}
.disaster-nowr5 {
  padding: 0.2vh 0.5vw;
  display: flex;
  align-items: center;
  margin-top: 2vh;
  margin-left: 1.5vw;
}

.disaster-top {
  img {
    width: 80%;
    cursor: pointer;
    height: auto;
  }
}
.name {
  display: block;
  width: 5vw;
  padding: 0.2vh 0.3vw;
  font-size: 0.5vw;
  color: #e8e8e8;
  letter-spacing: 0.1vw;
  background-size: 80% auto;
  background-repeat: no-repeat;
  white-space: nowrap;
  transition: opacity 1s;
  opacity: 0;
}
.name1 {
  display: block;
  width: 5vw;
  padding: 0.2vh 0.3vw;
  font-size: 0.5vw;
  color: #e8e8e8;
  letter-spacing: 0.1vw;
  background-size: 80% auto;
  background-repeat: no-repeat;
  white-space: nowrap;
  transition: opacity 1s;
  opacity: 100;
}
</style>